import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/recurring-deposit-calculator',
  component: () => import('../../routes/RecurringDepositCalculator.svelte'),
  card: {
    id: 'recurring-deposit',
    title: 'Recurring Deposit (RD)',
    description: 'Calculate maturity value of a bank recurring deposit with monthly contributions and compound interest.',
    icon: 'calendar_month',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/recurring-deposit-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Recurring Deposit (RD) Calculator – Free RD Maturity Calculator',
    description: 'Free recurring deposit calculator to estimate maturity value. Calculate RD returns with monthly deposits, annual interest rate, and tenure. See year-by-year growth breakdown.',
  },
};

export default meta;
